import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';

import * as styles from './FooterAdfoxBanner.css';
import { EListingBannerType } from '../../constants/banner';
import { AdfoxBanner } from '../Adfox/AdfoxBanner';
import { ClientComponent } from '../Adfox/ClientComponent';
import { useListingBanner } from '../Adfox/useListingBanner';

const BANNER_HEIGHT = 560;

export const FooterAdfoxBanner = () => {
  const { isHidden, onClick, onView, onLoad, onStub, onError } = useListingBanner({
    bannerType: EListingBannerType.Parallax,
  });

  if (isHidden) {
    return null;
  }

  return (
    <div className={styles['root']}>
      <ClientComponent>
        <ActionAfterViewObserver callback={onView} percentVisible={0.5} triggerOnce>
          <div onClick={onClick}>
            <AdfoxBanner
              ownerId={202100}
              params={{ p1: 'dbtyp', p2: 'y' }}
              width="100%"
              height={BANNER_HEIGHT}
              lazyLoad={{ fetchMargin: 100, mobileScaling: 1 }}
              onLoad={onLoad}
              onStub={onStub}
              onError={onError}
            />
          </div>
        </ActionAfterViewObserver>
      </ClientComponent>
    </div>
  );
};

FooterAdfoxBanner.displayName = 'FooterAdfoxBanner';
